module.exports = __webpack_public_path__ + "img/2018.933e9332.png";